import ActionTypes from './actionTypes';

export const setTime = time => dispatch => dispatch({ type: ActionTypes.SET_TIME, time });

export const nextTime = time => dispatch => dispatch({ type: ActionTypes.NEXT_TIME, time });

export const pastTime = time => dispatch => dispatch({ type: ActionTypes.PAST_TIME, time });
